import React, { useState, useEffect } from 'react';
import { Form, Row, InputGroup, Button, Table } from 'react-bootstrap';
import { CCol, CFormLabel, CFormFeedback, CFormInput, CButton } from '@coreui/react';
import { useDispatch } from 'react-redux';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import FormWrapper from '../../pagecomponents/Common/FormWrapper';
import { getMasterData, getCustomerData, getCustomerDetail } from '../../redux/slices/CustomerSlice';
import { addJob, editJob } from '../../redux/slices/JobSlice';
import { checkEmpty, toastMessage } from '../../helpers/utility.js';
import PageWrapper from '../../pagecomponents/Common/PageWrapper.js';
import useDebouncedValue from '../../helpers/useDebouncedValue';

const INIT_FORM_DATA = {
  client_Id: 1,
  doc_No: '',
  customer_Id: '',
  customer_Name: '',
  job_No: '', // automatic from database
  job_Date: format(new Date(), 'yyyy-MM-dd'),
  job_type_Code: '',
  job_currency_Code: 'USD',
  rate: '',
  job_Load_No: '',
  payment_Type: '',
  job_Cheque_No: '',
  jobCharge: [], // Array to store job charge data
};

const MASTER_DATA_PARAMS = {
  skip: 0,
  take: 2000,
  type: '',
  sorting: 'asc',
  sorting_key: 'created_at',
  filter: {},
};

const JobAddForm = ({ onSave, addCustomerModal, mode, data }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(INIT_FORM_DATA);
  const [masterJobTypeData, setMasterJobTypeData] = useState([]);
  const [masterPaymentModeData, setMasterPaymentModeData] = useState([]);
  const [masterJobchargeData, setMasterJobchargeData] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [customerSearch, setCustomerSearch] = useState('');
  const debouncedCustomerSearch = useDebouncedValue(customerSearch, 350);
  const pageName = 'Add Job Form';

  // useEffect(()=> {
  //     fetchMasterData();
  //     document.querySelector("input[name='customer_Name']").setAttribute("autocomplete", "off");
  // });

  useEffect(() => {
    fetchMasterData();
    document.querySelector("input[name='customer_Name']").setAttribute('autocomplete', 'off');
  }, [mode, data, dispatch]); // Dependency array to prevent unnecessary re-renders

  const fetchMasterData = async () => {
    try {
      const { payload } = await dispatch(getMasterData({ inputData: MASTER_DATA_PARAMS }));
      setMasterPaymentModeData(payload?.payment_mode);
      setMasterJobchargeData(payload?.job_charge);

      // Initialize job_charge array in formData
      if (mode && data) {
        const initialCharges = data.jobCharge.map((charge) => ({
          job_charge_Id: charge.job_charge_Id,
          customer_Id: charge.customer_Id,
          job_Id: charge.job_Id,
          charge_Name: charge.charge_Name,
          charge_Code: charge.charge_Code,
          charge_value: charge.charge_value || 0, // Ensure initialized value
        }));
        console.log('Initial Charges:', initialCharges);
        setFormData((prev) => ({
          ...prev,
          jobCharge: initialCharges, // Add job charges here
        }));
      } else {
        const initialCharges = payload?.job_charge.map((charge, index) => ({
          charge_Name: charge.charge_Name,
          charge_Code: charge.charge_Code,
          charge_value: 0,
        }));
        setFormData((prev) => ({ ...prev, jobCharge: initialCharges }));
      }
    } catch (err) {
      toastMessage('error', 'Failed to fetch data');
    } finally {
    }
  };

  useEffect(() => {
    if (mode && data) {
      // console.log("Incoming data:", data);

      getJobTypeAgaintCustomer(data.customer_Id, data.customer_Name);

      const initialCharges = data.jobCharge.map((charge) => ({
        job_charge_Id: charge.job_charge_Id,
        customer_Id: charge.customer_Id,
        job_Id: charge.job_Id,
        charge_Name: charge.charge_Name,
        charge_Code: charge.charge_Code,
        charge_value: charge.charge_value || 0, // Ensure initialized value
      }));
      // console.log("Initial Charges:", initialCharges);

      setFormData((prev) => ({
        ...prev,
        job_Id: data.job_Id || '',
        doc_No: data.doc_No || '',
        customer_Id: data.customer_Id || '',
        customer_Name: data.customer_Name || '',
        job_No: data.job_No || '',
        job_Date: format(new Date(data.job_Date), 'yyyy-MM-dd'),
        job_type_Code: data.job_type_Code || '',
        job_currency_Code: data.job_currency_Code || 'USD',
        rate: data.rate || '',
        job_Load_No: data.job_Load_No || '',
        payment_Type: data.payment_Type || '',
        job_Cheque_No: data.job_Cheque_No || '',
        jobCharge: initialCharges, // Add job charges here
      }));
    }
  }, [mode, data]);

  useEffect(() => {
    const searchValue = String(debouncedCustomerSearch || '').trim();

    if (!searchValue) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    let isMounted = true;
    const fetchSuggestions = async () => {
      try {
        const params = {
          sorting: 'asc',
          sorting_key: 'created_at',
          skip: 0,
          searchStr: searchValue,
          take: 100,
          filter: {
            customer_Id: 0,
            customer_Registration_No: '',
            customer_Code: '',
          },
          useLookupApi: true,
        };
        const { payload } = await dispatch(getCustomerData({ inputData: params }));

        if (isMounted) {
          setSuggestions(Array.isArray(payload?.data) ? payload.data : []);
          setShowSuggestions(true);
        }
      } catch (error) {
        if (isMounted) {
          setSuggestions([]);
          setShowSuggestions(false);
        }
      }
    };

    fetchSuggestions();
    return () => {
      isMounted = false;
    };
  }, [debouncedCustomerSearch, dispatch]);

  // useEffect(() => {
  //     if (masterJobchargeData?.length) {
  //         const updatedJobCharge = masterJobchargeData.map((item, index) => ({
  //             ...formData.jobCharge[index],
  //             charge_Name: item.charge_Name,
  //             charge_value: formData.jobCharge[index]?.charge_value || 0, // Preserve existing value
  //         }));

  //         setFormData((prev) => ({
  //             ...prev,
  //             jobCharge: updatedJobCharge,
  //         }));
  //     }
  // }, [masterJobchargeData]);

  const getJobTypeAgaintCustomer = async (customer_Id, customer_Name = '') => {
    let params = {
      sorting: 'asc',
      sorting_key: 'created_at',
      skip: 0,
      searchStr: customer_Name,
      take: 100,
      filter: {
        customer_Id: 0,
        customer_Registration_No: '',
        customer_Code: '',
      },
      useLookupApi: true,
    };
    const { payload } = await dispatch(getCustomerData({ inputData: params }));
    const customerId = customer_Id || payload?.data?.[0]?.customer_Id;

    if (customerId) {
      const detailResp = await dispatch(getCustomerDetail({ inputData: { customer_Id: customerId } }));
      setMasterJobTypeData(detailResp?.payload?.data?.[0]?.jobRate || []);
      return;
    }

    setMasterJobTypeData([]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'job_Date') {
      setFormData({
        ...formData,
        [name]: format(new Date(value), 'yyyy-MM-dd'), // Format the date
      });
    } else if (name === 'job_Load_No') {
      if (/^\d*\.?\d{0,2}$/.test(value)) {
        // Allow only numbers and up to 2 decimal places
        setFormData({
          ...formData,
          [name]: value,
          jobCharge: [
            {
              ...formData.jobCharge[0],
              charge_value: parseFloat(value) * formData.rate, // Multiply value and rate
            },
            ...formData.jobCharge.slice(1), // Copy the rest of the jobCharge array if needed
          ],
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSave = async () => {
    // console.log(formData);
    // return;
    if (formData.payment_Type === 'cheque' && checkEmpty(formData.job_Cheque_No)) {
      toastMessage('error', 'Enter cheque number');
    } else if (checkEmpty(formData.customer_Id)) {
      toastMessage('error', 'Enter valid customer');
    } else {
      let api = mode ? editJob : addJob;
      const { payload } = await dispatch(api({ inputData: formData }));
      console.log('het i am here from 2', payload);

      if (payload?.status === 'error') {
        // toastMessage("error", payload.msg || "An error occurred while saving.");
      } else {
        toastMessage(payload?.status || 'success', payload?.msg || 'Operation successful.');
        onSave();
      }
    }
  };

  const handleOnJobTypeSelect = (e) => {
    const { value } = e.target; // Selected job type code
    const selectedJobType = masterJobTypeData.find((jobType) => jobType.job_type_code === value);

    setFormData((prevState) => ({
      ...prevState,
      job_type_Code: value, // Update selected job type
      rate: selectedJobType?.rate || '', // Update rate based on the selection
      job_Load_No: '',
      jobCharge: [
        {
          ...formData.jobCharge[0],
          charge_value: 0, // Multiply value and rate
        },
        ...formData.jobCharge.slice(1), // Copy the rest of the jobCharge array if needed
      ],
    }));
  };

  const handleAutoComplete = (e) => {
    const { value } = e.target;
    // setFormData({ ...formData, [name]: value });

    setFormData((prevState) => ({
      ...prevState,
      customer_Id: '',
      customer_Name: value,
      job_type_Code: '',
      rate: '',
    }));

    setCustomerSearch(value);
    if (value.trim() === '') {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const onSelectCustomer = (customerData) => {
    setFormData((prevState) => ({
      ...prevState,
      customer_Id: customerData?.customer_Id || '',
      customer_Name: customerData?.customer_Name || '',
    }));

    (async () => {
      const detailAction = await dispatch(
        getCustomerDetail({ inputData: { customer_Id: customerData?.customer_Id || 0 } }),
      );
      setMasterJobTypeData(detailAction?.payload?.data?.[0]?.jobRate || []);
    })();

    setCustomerSearch('');
    setSuggestions([]);
    setShowSuggestions(false);
  };

  // Handle job charge updates
  const handleChargeChange = (index, value) => {
    // Remove leading zero but allow "0" if it's the only character
    if (value.length > 1 && value.startsWith('0')) {
      value = value.replace(/^0+/, '');
    }

    if (/^\d*\.?\d{0,2}$/.test(value)) {
      // Allow only numbers and up to 2 decimal places
      setFormData((prev) => {
        const updatedJobCharge = [...prev.jobCharge];

        // Ensure the index exists in the array
        if (!updatedJobCharge[index]) {
          updatedJobCharge[index] = {}; // Initialize if undefined
        }

        updatedJobCharge[index] = {
          ...updatedJobCharge[index],
          charge_value: value,
        };

        return { ...prev, jobCharge: updatedJobCharge }; // **Return the updated state**
      });
    }
  };

  const calculateTotal = () => {
    const total = formData.jobCharge.reduce((sum, charge) => {
      const value = parseFloat(charge?.charge_value) || 0; // Convert to number and handle undefined/null
      return sum + value;
    }, 0);

    return total;
  };

  return (
    <PageWrapper pageName={pageName}>
      <Row className="row-xs mb-2">
        <CCol md={6}>
          <Row className="row-xs mb-2">
            <CCol md={6}>
              <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="doc_No">
                Doc No
              </CFormLabel>
              <CFormInput
                type="text"
                id="doc_No"
                name="doc_No"
                value={formData.doc_No}
                onChange={handleInputChange}
                required
              />
              <CFormFeedback invalid>Doc</CFormFeedback>
            </CCol>
            <CCol md={6}>
              <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="job_Date">
                Job Date
              </CFormLabel>
              <InputGroup className="input-group reactdate-pic">
                <InputGroup.Text className="input-group-text">
                  <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
                </InputGroup.Text>
                <DatePicker
                  className="form-control"
                  name="job_Date"
                  id="job_Date"
                  selected={formData.job_Date ? new Date(formData.job_Date) : null} // Convert to Date object
                  onChange={(date) => {
                    const event = {
                      target: {
                        name: 'job_Date',
                        value: date,
                      },
                    };
                    handleInputChange(event); // Simulate an event for compatibility
                  }}
                  dateFormat="yyyy-MM-dd" // Match the desired format
                  // isClearable // Optional: Allow clearing the date
                />
              </InputGroup>
              <CFormFeedback invalid>Select Job Date</CFormFeedback>
            </CCol>
            <CCol md={12}>
              <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_Name">
                Search Customer
              </CFormLabel>
              <div className="hsc-wrapper">
                <InputGroup className="input-group">
                  <CFormInput
                    type="text"
                    id="customer_Name"
                    name="customer_Name"
                    value={formData.customer_Name}
                    onChange={handleAutoComplete}
                    required
                    autoComplete="false"
                  />
                  <Button
                    variant=""
                    className="btn btn-primary br-ts-0 br-bs-0"
                    type="button"
                    onClick={addCustomerModal}
                  >
                    <i className="fa fa-plus"></i>
                  </Button>
                </InputGroup>
                <CFormFeedback invalid>Search or Add Customer</CFormFeedback>
                {suggestions && suggestions.length > 0 && (
                  <div
                    className="header-search-container"
                    onMouseDown={(e) => e.preventDefault()}
                    onPointerDown={(e) => e.preventDefault()}
                  >
                    <div className="hs">
                      {/* <Container fluid>
                                                <Row className="d-flex justify-content-between mt-3 align-items-stretch"> */}
                      {suggestions?.map((suggestion, index) => (
                        // <Col xs={4} key={index}>
                        <div
                          key={suggestion.customer_Id || index}
                          className="main-message-list header-search-element"
                          onPointerDown={(e) => {
                            e.preventDefault();
                            onSelectCustomer(suggestion);
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          <strong>
                            {suggestion?.customer_Name} - {suggestion?.customer_Code}{' '}
                          </strong>
                          <span>{suggestion?.customer_Email}</span>
                          <span>{suggestion?.customer_Mobile}</span>
                        </div>
                        // </Col>
                      ))}
                      {/* </Row>
                                            </Container> */}
                    </div>
                  </div>
                )}
              </div>
            </CCol>
            <CCol md={6}>
              <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="job_type_Code">
                Job Type
              </CFormLabel>
              <Form.Select
                className="form-control"
                id="job_type_Code"
                name="job_type_Code"
                value={formData.job_type_Code}
                onChange={handleOnJobTypeSelect}
                required
              >
                <option value="">Select {formData.customer_Id ? 'Job Type' : 'Customer'}</option>
                {masterJobTypeData?.map((option, index) => (
                  <option key={index} value={option.job_type_code}>
                    {option.job_type_Name}
                  </option>
                ))}
              </Form.Select>
              <CFormFeedback invalid>Job Type</CFormFeedback>
            </CCol>
            <CCol md={3}>
              <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="rate">
                Rate
              </CFormLabel>
              <CFormInput type="text" id="rate" name="rate" value={formData.rate} disabled />
            </CCol>
            <CCol md={3}>
              <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="job_Load_No">
                Vehicles
              </CFormLabel>
              <CFormInput
                type="text"
                id="job_Load_No"
                name="job_Load_No"
                value={formData.job_Load_No}
                onChange={handleInputChange}
                required
                // pattern="[0-9]{10}"
              />
              <CFormFeedback invalid>No of Vch</CFormFeedback>
            </CCol>
          </Row>
        </CCol>
        <CCol md={6}>
          <Row className="row-xs mb-2 mg-md-auto pb-3 w-75 pt-3">
            <Table className="table table-bordered text-nowrap mb-0">
              <thead>
                <tr>
                  <th style={{ width: '60%' }}>Description</th>
                  <th style={{ width: '40%' }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {masterJobchargeData?.map((row, index) => (
                  <tr key={index}>
                    <td>{row.charge_Name}</td>
                    <td>
                      <CFormInput
                        className="form-control-sm"
                        type="text"
                        id={`charge_${index}`}
                        name={`charge_${index}`}
                        value={formData.jobCharge[index]?.charge_value || 0}
                        onChange={(e) => handleChargeChange(index, e.target.value)}
                      />
                    </td>
                  </tr>
                ))}
                <tr>
                  <th>TOTAL</th>
                  <td>
                    <CFormInput type="text" id="charges_total" name="charges_total" value={calculateTotal()} disabled />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Row>

          {/* Action Button */}
          <Row className="row-xs mb-2">
            <CCol xs={12} className="mt-10">
              <CButton color="primary" className="btn btn-sm float-end" type="submit">
                Save Changes
              </CButton>
              <CButton color="secondary" className="btn btn-sm float-end me-2" onClick={onSave}>
                Close
              </CButton>
            </CCol>
          </Row>
        </CCol>
      </Row>
    </PageWrapper>
  );
};

export default JobAddForm;
